import { useEffect, useState } from "react";

function ListeRepas() {
  const [repas, setRepas] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
fetch(" https://api.famillerocher.fr/api.food.php", {
  method: "GET",
  credentials: "omit"
})
      .then(res => res.json())
      .then(data => {
        setRepas(data);
        setLoading(false);
      })
      .catch(err => {
        console.error("Erreur API :", err);
        setLoading(false);
      });
  }, []);

  if (loading) return <p>Chargement des repas 🍽️...</p>;

  return (
    <div>
      <h2>Liste des repas</h2>
      <ul>
        {repas.map(repas => (
          <li key={repas.id_food}>
            {repas.fod_libelle}
          </li>
        ))}
      </ul>
    </div>
  );
}

export default ListeRepas;
